module.exports = __webpack_public_path__ + "static/media/Vcstartimg2.901856c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Vcstartimg2.png
// module id = 1180
// module chunks = 0